










import { identicon } from "@/lib/identicon";
import { Wallet } from "@/models/wallet";
import { defineComponent, computed } from "@vue/composition-api";

export default defineComponent({
  props: {
    seed: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "base64"
    },
    size: {
      type: Number,
      default: 45
    },
    src: String
  },
  setup(props) {
    return {
      identicon: computed(() => {
        const icon = identicon(props.seed, props.type);
        return icon ? icon.toDataURL() : "";
      })
    };
  }
});
